<div class="quote-fields" [formGroup]="frmOfferFilters">

  <mat-form-field appearance="standard" *ngIf="this.quote?.quote?.quoteRequestState?.quoteRequestType.replace(' ', '') !== quoteRequestType.QuickQuote">
    <mat-label>Product Type</mat-label>
    <mat-select [formControl]="productTypes" name="productTypes"  [disabled]="(this.productTypes$ | async)?.length <= 1" multiple (selectionChange)="productTypeChanged($event)">
      <mat-select-trigger>
        {{ productTypes.value ? productTypes?.value[0] : '' }}
        <span *ngIf="(this.productTypes$ | async)?.length > 1 && !(productTypes$ | async)?.includes('Show All')" class="example-additional-selection">
          (+{{ (this.productTypes$ | async)?.length - 1 }} {{ (this.productTypes$ | async)?.length === 2 ? 'other' : 'others' }})
        </span>
      </mat-select-trigger>
      <mat-option *ngFor="let productTypeOption of (this.productTypes$ | async) || this.productTypesValues" [value]="productTypeOption">{{productTypeOption}}</mat-option>
    </mat-select>
  </mat-form-field>

  <!-- <mat-form-field appearance="standard">
    <mat-label>Product Type</mat-label>
    <mat-select [formControl]="productTypes" name="productTypes2" multiple>
      <mat-option *ngFor="let productTypeOption of (this.productTypes$ | async)" [value]="productTypeOption">{{productTypeOption}}</mat-option>
    </mat-select>
  </mat-form-field> -->

  <div style="padding-left: 10px">
    <p style="display: block; font-size: 12px">Contract Lengths (months)</p>

    <app-contract-lengths 
      formControlName="contractLengths"
      [FilterMode]="true"
      [showAllButton]="true"
      [showPlusButton]="false"
      (notifyAllChanged)="allContractLengthsSelected($event)"
      (contractLengthClicked)="contractLengthsChanged($event)"
    >
    </app-contract-lengths>

  </div>
  <div style="padding-top: 45px; padding-left: 10px" *ngIf="this.quote?.quote?.quoteRequestState?.quoteRequestType.replace(' ', '') !== quoteRequestType.QuickQuote">
    <mat-checkbox id="sweetSpotCheckbox" color="primary" formControlName="sweetSpotCheckbox"
      name="sweetSpotCheckbox" (change)="sweetSpotCheckboxChanged($event)">
      <span id="checkboxText">Include Sweet Spot for the full range</span>
    </mat-checkbox>
  </div>
</div>